export default __webpack_public_path__ + "static/media/reward.71f9fa3e.svg";